import React from 'react';
import { Modal } from 'react-bootstrap';

import Form from './Form';

import { useContext } from '../Context';

export default function ModalForm() {
  const { dispatch, actions } = useContext();

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show
      onHide={() => actions.hideModal(dispatch)}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Edit Prospect
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form />
      </Modal.Body>
    </Modal>
  );
}
